import React from 'react'
import { Form, Card, Avatar, Tag, Typography } from 'antd'

const SAMPLE: Record<string, string> = {
  who: 'Marcus Pierre', class_year: '2001', amount: '250', fund: 'Annual Fund',
  event_title: 'Homecoming Weekend', guests: '2', role: 'Engineer', org: 'Acme',
  reactor: 'Andrea Joseph', others_count: '16', activity_label: 'gift',
}

function fill(tpl?: string): string {
  return (tpl ?? '').replace(/\{(\w+)\}/g, (_m, k: string) => SAMPLE[k] ?? '')
}

/** Read-only preview of the feed item + notification produced by the current form. */
export function LivePreview() {
  const form = Form.useFormInstance()
  // useWatch triggers re-render; fall back to getFieldsValue() for the initial
  // snapshot so the preview renders correctly even before fields are touched.
  Form.useWatch([], form)
  const values = form.getFieldsValue(true) as {
    create_activity?: boolean
    create_notification?: boolean
    activity_template?: { text_template?: string; audience?: { type?: string } }
    notification_template?: { title_template?: string; body_template?: string }
  }

  const createActivity = values.create_activity
  const createNotification = values.create_notification
  const activity = values.activity_template
  const notif = values.notification_template

  const generic = activity?.audience?.type === 'generic'
  // Treat undefined as true so the preview renders when form hasn't hydrated watch yet
  const showActivity = createActivity !== false
  const showNotification = createNotification === true

  return (
    <div style={{ position: 'sticky', top: 16 }}>
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>Live preview</Typography.Text>
      {showActivity && (
        <Card size="small" style={{ marginTop: 8 }} title="Activity feed">
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            <Avatar>{generic ? '★' : 'MP'}</Avatar>
            <div>
              <b>{generic ? 'MUAA Alumni' : 'Marcus Pierre'}</b> {fill(activity?.text_template)}
              {activity?.audience?.type === 'members' && <Tag style={{ marginLeft: 8 }}>· with Andrea Joseph</Tag>}
            </div>
          </div>
        </Card>
      )}
      {showNotification && (
        <Card size="small" style={{ marginTop: 8 }} title="Notification">
          <b>{fill(notif?.title_template)}</b>
          <div style={{ color: '#888' }}>{fill(notif?.body_template)}</div>
        </Card>
      )}
    </div>
  )
}
